// src/pages/extrato/PaginaExtratoMoedas.jsx
import React, { useEffect, useState, useCallback } from "react";
import "./paginaExtratoMoedas.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";

const API_BASE = process.env.REACT_APP_API_BASE;
const ITENS_POR_PAGINA = 6;

const FILTROS = [
  { valor: "todos", label: "Todos" },
  { valor: "compra", label: "Recargas" },
  { valor: "gasto", label: "Gastos" },
  { valor: "bonus", label: "Bônus" },
];

const PaginaExtratoMoedas = () => {
  const [transacoes, setTransacoes] = useState([]);
  const [pagina, setPagina] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [filtroTipo, setFiltroTipo] = useState("todos");
  const [resumo, setResumo] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState("");

  const totalPaginas = Math.max(1, Math.ceil(totalRegistros / ITENS_POR_PAGINA));

  const carregarExtrato = useCallback(async () => {
    setCarregando(true);
    setErro("");

    try {
      const res = await fetch(
        `${API_BASE}/extrato-moedas.php?limite=${ITENS_POR_PAGINA}&pagina=${pagina}&tipo=${filtroTipo}`,
        { credentials: "include" }
      );
      const data = await res.json();

      if (data.status === "sucesso") {
        setTransacoes(Array.isArray(data.transacoes) ? data.transacoes : []);
        setTotalRegistros(data.total_registros ?? 0);
        setResumo(data.resumo || null);
      } else {
        setErro("Não foi possível carregar o extrato.");
      }
    } catch {
      setErro("Erro ao comunicar com o servidor.");
    }

    setCarregando(false);
  }, [pagina, filtroTipo]);

  useEffect(() => {
    carregarExtrato();
  }, [carregarExtrato]);

  const trocarFiltro = (novoFiltro) => {
    setFiltroTipo(novoFiltro);
    setPagina(1); // reseta a paginação ao trocar de filtro
  };

  const formatarDataHora = (isoStr) => {
    if (!isoStr) return "";
    const d = new Date(isoStr.replace(" ", "T"));
    if (Number.isNaN(d.getTime())) return "";
    const data = d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" });
    const hora = d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
    return `${data} às ${hora}`;
  };

  return (
    <div className="painel-container extrato-container">
      <button
        className="btn-voltar"
        onClick={() => (window.location.href = "/acesso")}
      >
        <FontAwesomeIcon icon={faArrowLeft} /> Voltar
      </button>

      <img src="/assets/logo2.png" alt="Logo" className="painel-logo" />

      <div className="extrato-header">
        <h2>Extrato de moedas</h2>
        <p>Todo o histórico de compras e uso das suas moedas.</p>
      </div>

      {/* 🆕 CARDS DE RESUMO */}
      {resumo && (
        <div className="extrato-resumo-cards">
          <div className="extrato-resumo-card">
            <span className="extrato-resumo-card-label">Gasto (7 dias)</span>
            <strong className="extrato-resumo-card-valor negativo">
              {resumo.gasto_7_dias}
            </strong>
          </div>

          <div className="extrato-resumo-card">
            <span className="extrato-resumo-card-label">Comprado (total)</span>
            <strong className="extrato-resumo-card-valor positivo">
              +{resumo.comprado_total}
            </strong>
          </div>

          <div className="extrato-resumo-card">
            <span className="extrato-resumo-card-label">Saldo atual</span>
            <strong className="extrato-resumo-card-valor">
              {resumo.saldo_atual}
            </strong>
          </div>
        </div>
      )}

      {/* 🆕 CHIPS DE FILTRO */}
      <div className="extrato-filtros">
        {FILTROS.map((f) => (
          <button
            key={f.valor}
            className={`extrato-filtro-chip ${filtroTipo === f.valor ? "ativo" : ""}`}
            onClick={() => trocarFiltro(f.valor)}
          >
            {f.label}
          </button>
        ))}
      </div>

      {erro && <div className="extrato-alerta-erro">{erro}</div>}

      {carregando && <p className="extrato-carregando">Carregando...</p>}

      {!carregando && transacoes.length === 0 && !erro && (
        <p className="extrato-vazio">Nenhuma movimentação encontrada.</p>
      )}

      {!carregando && transacoes.length > 0 && (
        <>
          <div className="extrato-lista">
            {transacoes.map((t) => (
              <div key={t.id} className="extrato-item">
                <img src="/moeda.png" alt="Moeda" className="extrato-item-icone" />

                <div className="extrato-item-info">
                  <span className="extrato-item-motivo">{t.motivo}</span>
                  <span className="extrato-item-data">{formatarDataHora(t.data)}</span>
                </div>

                <div className="extrato-item-valores">
                  <span
                    className={`extrato-item-quantidade ${
                      t.quantidade < 0 ? "negativo" : "positivo"
                    }`}
                  >
                    {t.quantidade > 0 ? "+" : ""}
                    {t.quantidade}
                  </span>
                  <span className="extrato-item-saldo-apos">
                    saldo: {t.saldo_apos}
                  </span>
                </div>
              </div>
            ))}
          </div>

          {totalPaginas > 1 && (
            <div className="extrato-paginacao">
              <button
                disabled={pagina === 1}
                onClick={() => setPagina((p) => p - 1)}
              >
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>

              <span>{pagina} / {totalPaginas}</span>

              <button
                disabled={pagina === totalPaginas}
                onClick={() => setPagina((p) => p + 1)}
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PaginaExtratoMoedas;